import React from 'react';
import { useIsMobileLayout } from '../../../../hooks/useIsMobileLayout';
import { getIntl } from '../../../../utils/intl';
import Stack from '../../../v2BaseComponents/Stack';
import { Platform, View } from 'react-native';
import { colors } from '../../../../utils/theme';
import Logo from './Logo';
import { getSpacing } from '../../../../utils/spacing';
import Text from '../../../v2BaseComponents/Text';
import ProfessionalIndicator from '../../../shared/ProfessionalIndicator';
import { useCapturedUrlUserType } from '../../../../hooks/useUrlAppParams';

const intl = getIntl('WelcomeScreenHeader', {
    primaryRecord: 'Primary Record',
    mobilePrimaryRecord: 'Primary\nRecord',
    primaryRecordInc: 'Primary Record, Inc.',
    webBased: 'Web-based application',
});

export type WelcomeHeaderOwnProps = {};

export type WelcomeHeaderProps = WelcomeHeaderOwnProps;

const iconHeights = {
    mobile: 70,
    desktop: 110,
};

const paddings = {
    mobile: 24,
    desktop: 32,
};

const WelcomeHeader: React.FC<WelcomeHeaderProps> = () => {
    const isMobile = useIsMobileLayout();
    const iconHeight = isMobile ? iconHeights.mobile : iconHeights.desktop;
    const padding = isMobile ? paddings.mobile : paddings.desktop;
    const urlUserType = useCapturedUrlUserType();

    return (
        <Stack
            space={getSpacing(4)}
            horizontal
            style={{
                justifyContent: 'flex-start',
            }}
        >
            <View
                style={{
                    backgroundColor: colors['White'],
                    height: iconHeight + padding,
                    width: iconHeight + padding,
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: iconHeight / 5,
                    boxShadow: 'rgba(0, 0, 0, 0.27) 0px 2px 4px',
                }}
            >
                <Logo height={iconHeight} style={{ aspectRatio: 1.03 }} />
            </View>
            <Stack flex={1} padding={isMobile ? 0 : 8} vertical space={getSpacing(2)} justify="space-between">
                <Stack vertical space={8}>
                    <Text
                        variant="h1"
                        style={{
                            lineHeight: isMobile ? 36 : 60,
                            fontWeight: '900',
                            fontFamily: 'OverpassExtraBold',
                            fontSize: isMobile ? 34 : 60,
                        }}
                    >
                        {intl(isMobile ? 'mobilePrimaryRecord' : 'primaryRecord')}
                    </Text>
                    {urlUserType === 'professional' ? <ProfessionalIndicator /> : null}
                </Stack>
                <Stack vertical>
                    <Text
                        variant={isMobile ? 'caption-1' : 'h5'}
                        style={{
                            fontFamily: 'OverpassBold',
                            letterSpacing: 0,
                        }}
                    >
                        {intl('primaryRecordInc')}
                    </Text>
                    {Platform.OS === 'web' ? (
                        <Text
                            variant={isMobile ? 'input-label' : 'h5'}
                            style={{
                                color: colors['Gray-Text'],
                                letterSpacing: 0,
                            }}
                        >
                            {intl('webBased')}
                        </Text>
                    ) : null}
                </Stack>
            </Stack>
        </Stack>
    );
};

export default React.memo(WelcomeHeader);
